import './Ck_Schemas.css';
import { IoMdAdd } from "react-icons/io";
import { FaEye, FaEdit } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { useCKSchemaLogic } from './CK_SchemaLogic';

const getEnabledDisplay = (value) => {
    if (value === true) return { label: "Yes", className: "enabled" };
    if (value === false) return { label: "No", className: "disabled" };

    if (typeof value === "number") {
        if (value === 1) return { label: "Yes", className: "enabled" };
        if (value === 0) return { label: "No", className: "disabled" };
    }

    if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        if (["true", "1", "yes", "enabled"].includes(normalized)) {
            return { label: "Yes", className: "enabled" };
        }
        if (["false", "0", "no", "disabled"].includes(normalized)) {
            return { label: "No", className: "disabled" };
        }
    }

    return { label: "NA", className: "unknown" };
};

const Ck_Schemas = () => {
    const {
        displayedSchemas,
        openJSONModal,
        jsonSchema,
        isEditMode,
        schemaErrors,
        currentPage,
        pageSize,
        search,
        jsonText,
        startEntry,
        endEntry,
        totalRecords,
        totalPages,
        currentSchemaName,
        setOpenJSONModal,
        setCurrentPage,
        setPageSize,
        setSearch,
        addSchema,
        viewJSON,
        editSchema,
        handleEnableEdit,
        handleJsonChange,
        handleDownloadJSON,
        handleUpdateToServer,
        handleCancelEdit,
        handleCloseModal
    } = useCKSchemaLogic();

    return (
        <div className="main-content">

            {/* HEADER */}
            <div className="custom-header-cks">
                <span className="title-req">Ck Schemas</span>
                <button onClick={addSchema}><IoMdAdd /> Create Schema</button>
            </div>
            <div className="mt-3 datasetlist-topbar-Schema">
                {/* SEARCH – LEFT */}
                <div className="datasetlist-search-Schema">
                    <CiSearch className="datasetlist-search-Schema-icon" />
                    <input
                        type="text"
                        placeholder="Search by Label"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                </div>

                {/* PAGINATION – RIGHT */}
                <div className="datasetlist-pagination-Schema">
                    <span className="datasetlist-showing-Schema">
                        Showing {startEntry} to {endEntry} of {totalRecords} entries
                    </span>

                    <span>Show</span>
                    <select
                        className=" form-select datasetlist-pagesize-Schema"
                        value={pageSize}
                        onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setCurrentPage(1);
                        }}>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>

                    <ul className="Schema-pagination-buttons">
                        <li>
                            <button
                                className="page-btn-1"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}>
                                &lt;
                            </button>
                        </li>

                        <li>
                            <button className="page-btn active">
                                {currentPage}
                            </button>
                        </li>

                        <li>
                            <button
                                className="page-btn-1"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}>
                                &gt;
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            {/* TABLE */}
            <div className="table-content-schema mt-3">
                <table className="table schema-table">
                    <thead>
                        <tr>
                            <th>Schema Name</th>
                            <th>Label</th>
                            <th>Dataset ID</th>
                            <th>Version</th>
                            <th>Purpose</th>
                            <th>Enabled</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {displayedSchemas.length === 0 ? (
                            <tr>
                                <td colSpan="7" className="text-center">No Records Found</td>
                            </tr>
                        ) : (
                            displayedSchemas.map((req, index) => (
                                (() => {
                                    const enabledDisplay = getEnabledDisplay(req.enabled);

                                    return (
                                        <tr key={req._id || index}>
                                            <td>{req.schema_name}</td>
                                            <td>{req.label || "NA"}</td>
                                            <td>{req.dataset_id || "NA"}</td>
                                            <td>{req.version || "NA"}</td>
                                            <td>{req.purpose}</td>
                                            <td>
                                                <span className={`schema-enabled-badge ${enabledDisplay.className}`}>
                                                    {enabledDisplay.label}
                                                </span>
                                            </td>
                                            <td>
                                                <FaEye size={16} onClick={() => viewJSON(req._id)} style={{ cursor: "pointer", color: "#09c", marginRight: 12 }} />
                                                <FaEdit size={16} onClick={() => editSchema(req._id)} style={{ cursor: "pointer", color: "#09c" }} />
                                            </td>
                                        </tr>
                                    );
                                })()
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {openJSONModal && (
                <div className="json-modal-overlay1">
                    <div className="json-modal-container1">

                        {/* HEADER */}
                        <div className="json-modal-header1">
                            <h4>Generated CK_Schema JSON: ({currentSchemaName})</h4>


                            <div className="json-actions">
                                {!isEditMode && (
                                    <div className='json-action-div'>
                                        <button className='json-dw' onClick={handleDownloadJSON}>Download</button>
                                    </div>
                                )}
                                {!isEditMode ? (
                                    <button className="json-ed-ck" onClick={handleEnableEdit}>
                                        Edit
                                    </button>
                                ) : (
                                    <div className='json-action-div'>
                                        <button className='json-dw' onClick={handleDownloadJSON}>Download</button>
                                        <button className="json-ed-ck" onClick={handleUpdateToServer}>
                                            Update
                                        </button>
                                    </div>
                                )}

                                <MdClose
                                    size={22}
                                    onClick={handleCloseModal}
                                    style={{ cursor: "pointer" }}
                                />
                            </div>
                        </div>

                        {/* BODY */}
                        <div className="json-modal-body1">
                            <div className="json-editor-container">

                                {isEditMode && (
                                    <MdClose
                                        size={20}
                                        className="json-cancel-inside"
                                        onClick={handleCancelEdit} />
                                )}

                                {!isEditMode && (
                                    <pre className="json-dark-box1">
                                        {JSON.stringify(jsonSchema, null, 2)}
                                    </pre>
                                )}

                                {isEditMode && (
                                    <textarea
                                        className="json-editor"
                                        value={jsonText}
                                        onChange={handleJsonChange} />
                                )}

                            </div>

                            {schemaErrors.json && (
                                <p className="error-text">{schemaErrors.json}</p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Ck_Schemas;
